<template>
  <div class="drop--detail__container">
    <ContextTitle :title="$t('drops.toggled_units')" class="drop--detail__title">
      <template #custom--icon>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on" style="color: #faae20; padding-right: 2px;" v-if="recomendedPallet.warnings.length > 0"><i class="fas fa-exclamation-triangle"></i></span>
            </template>
            <template>
              <span style="display: block;" v-for="(warning, index) in recomendedPallet.warnings" :key="index">{{$t(`drops.${warning.msg}`)}}</span>
            </template>
        </v-tooltip>
      </template>
    </ContextTitle>
    <ContextItemNoEditable
    :iconTooltip="$t('drops.total_weight')"
    class="drop--detail__info"
    :icon="'fas fa-box'"
    :attribute="computeTotalWeight.attribute"
    :value="computeTotalWeight.value"
    :isCopyable="false"
    />
    <ContextItemNoEditable
    :iconTooltip="$t('drops.total_volume')"
    class="drop--detail__info"
    :icon="'fas fa-arrows-alt'"
    :attribute="computeTotalVolume.attribute"
    :value="computeTotalVolume.value"
    :isCopyable="false"
    />
    <ContextItemNoEditable
      :iconTooltip="$t('drops.number_of_toggled_units')"
      class="drop--detail__info"
      :icon="'fas fa-layer-group'"
      :attribute="$t('drops.number_of_toggled_units')"
      :value="unitsArray.length.toString()"
      :isCopyable="false"
    />
    <!-- <ContextInfo class="drop--detail__info" :icon="'fas fa-arrows-alt'" :isLoading="computeOrder.isLoading" :attribute="computeOrder.attribute" :value="computeOrder.value" /> -->
  </div>
</template>

<script>
import { dropHelpers } from '@/_helpers'
import { mapGetters } from 'vuex'
import ContextItemNoEditable from '@/components/wrld/generic/ContextItemNoEditable.vue'
import ContextTitle from '@/components/drops/detail/ContextTitle.vue'
import Pallet from '@/plugins/pallet-recommendation.js'
export default {
  name: 'DropContextToggledUnits',
  components: {
    ContextItemNoEditable,
    ContextTitle
  },
  props: {
    unitsArray: Array
  },
  computed: {
    ...mapGetters([
      'getDropTree'
    ]),
    computedDropTree () {
      return this.getDropTree(this.$route.params.dropID, false)
    },
    computeTotalWeight: function () {
      if (this.unitsArray.length > 0) {
        let totalWeight = 0
        this.unitsArray.forEach((unitObject) => {
          const unit = this.computedDropTree.find(({ id }) => unitObject.id === id)
          if (unit != null) {
            if (unit.children.length > 0) {
              totalWeight += dropHelpers.calculateUnitWeight(unit)
            } else {
              totalWeight += unit.weight
              // unit.items.forEach((item) => {
              //   totalWeight += item.weight
              // })
            }
          } else {
            if (unitObject.children.length > 0) {
              totalWeight += dropHelpers.calculateUnitWeight(unitObject)
            } else {
              totalWeight += unitObject.weight
              // unitObject.items.forEach((item) => {
              //   totalWeight += item.weight
              // })
            }
          }
        })
        return { attribute: this.$t('drops.weight_is'), value: this.$options.filters.roundValueWeight(totalWeight, 0) + ' kg', isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeTotalVolume: function () {
      if (this.unitsArray.length > 0) {
        let totalVolume = 0
        this.unitsArray.forEach((unit) => {
          totalVolume += (unit.dimensions.width * unit.dimensions.length * unit.dimensions.height) * 0.000001
        })
        return { attribute: this.$t('drops.volume_is'), value: this.$options.filters.roundValue(totalVolume, 1) + ' m³', isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeOrder: function () {
      if (this.unitsArray.length > 0) {
        let totalVolume = 0
        this.unitsArray.forEach((unit) => {
          totalVolume += (unit.dimensions.width * unit.dimensions.length * unit.dimensions.height) * 0.000001
        })
        return { attribute: 'Dimensions', value: this.$options.filters.roundValue(totalVolume, 1) + ' m³', isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    recomendedPallet () {
      let pallet = new Pallet(this.unitsArray)
      let recommendations = pallet.calculateRecommendations().recomendedDims
      recommendations['warnings'] = pallet.warnings
      return recommendations
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
